(function () {
  function init(root) {
    if (!root) return;

    // prevent double-binding
    if (root.dataset.gdInit === "1") return;
    root.dataset.gdInit = "1";

    const search = root.querySelector(".gd-search__input");
    const clearBtn = root.querySelector(".gd-search__clear");
    const popularBlock = root.querySelector(".gd-popular");
    const noResults = root.querySelector(".gd-noResults");

    const cards = Array.from(root.querySelectorAll(".gd-card"));
    const scopeButtons = Array.from(root.querySelectorAll(".gd-toggleGroup .gd-toggle"));
    const alphaButtons = Array.from(root.querySelectorAll(".gd-alphaTabs .gd-alpha"));

    // If these are missing, the DOM doesn't match what we rendered
    if (!search || cards.length === 0 || scopeButtons.length === 0 || alphaButtons.length === 0) {
      // mark so we can see it in DOM
      root.dataset.gdInit = "broken";
      return;
    }

    let activeScope = "all";
    let activeAlpha = "all";

    function setActive(btns, activeBtn) {
      btns.forEach((b) => {
        const isActive = b === activeBtn;
        b.classList.toggle("is-active", isActive);
        b.setAttribute("aria-selected", isActive ? "true" : "false");
      });
    }

    function alphaMatch(letter) {
      if (activeAlpha === "all") return true;
      const L = (letter || "").toUpperCase();
      const code = L.charCodeAt(0);
      if (!(code >= 65 && code <= 90)) return false;

      if (activeAlpha === "ag") return code >= 65 && code <= 71;
      if (activeAlpha === "hn") return code >= 72 && code <= 78;
      if (activeAlpha === "ot") return code >= 79 && code <= 84;
      if (activeAlpha === "uz") return code >= 85 && code <= 90;
      return true;
    }

    function scopeMatch(scope) {
      if (activeScope === "all") return true;
      return scope === activeScope;
    }

    function applyFilters() {
      const q = search.value.trim().toLowerCase();
      const hasText = q.length > 0;

      if (popularBlock) popularBlock.hidden = hasText;
      if (clearBtn) clearBtn.hidden = !hasText;

      let shown = 0;

      cards.forEach((card) => {
        const name = (card.getAttribute("data-name") || "").toLowerCase();
        const scope = card.getAttribute("data-scope") || "country";
        const letter = card.getAttribute("data-letter") || "";

        const matchesSearch = !hasText || name.includes(q);
        const matchesScope = scopeMatch(scope);
        const matchesAlpha = hasText ? true : alphaMatch(letter);

        const show = matchesSearch && matchesScope && matchesAlpha;
        card.hidden = !show;
        if (show) shown++;
      });

      if (noResults) noResults.hidden = shown !== 0;
    }

    scopeButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        activeScope = btn.getAttribute("data-scope") || "all";
        setActive(scopeButtons, btn);
        applyFilters();
      });
    });

    alphaButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        activeAlpha = btn.getAttribute("data-alpha") || "all";
        setActive(alphaButtons, btn);
        applyFilters();
      });
    });

    search.addEventListener("input", () => {
      if (search.value.trim() !== "" && activeAlpha !== "all") {
        activeAlpha = "all";
        const allBtn = alphaButtons.find((b) => (b.getAttribute("data-alpha") || "") === "all");
        if (allBtn) setActive(alphaButtons, allBtn);
      }
      applyFilters();
    });

    if (clearBtn) {
      clearBtn.addEventListener("click", () => {
        search.value = "";
        search.focus();
        applyFilters();
      });
    }

    applyFilters();
  }

  function boot(container) {
    (container || document).querySelectorAll("[data-gd-destinations]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot());
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    boot(event.target);
  });
})();
